import axios from "axios";

export const baseUrl="/";
// export const baseUrl="http://localhost:6075/";

export const loginApi = async (msisdn:any) => {
    const response = await axios.post(`${baseUrl}api/v1/login`, {
        msisdn: msisdn
    });
    return response;
};

const Integrated_API_URL = "https://api-msl-movie.uvcann.com/";

export const SendOtpAPI = async (msisdn:any) => {
    const response = await axios.post(`${Integrated_API_URL}OTP/SendOTP`, {
        msisdn
    });
    return response;
}

export const VerifyOtpAPI = async (msisdn:any, otp:any,otp_ref:any,ext_ref:any) => {
    const response = await axios.post(`${Integrated_API_URL}OTP/verifyOTP`, {
        msisdn,
        otp_ref,
        otp,
        ext_ref
    });
    return response;
}

export const unsubscribeAPI=async(msisdn:any)=>{
    const response=await axios.post(`${Integrated_API_URL}deactivate-user`,{msisdn});
    return response;
}